import Lottie from "lottie-react";
import saveButtonJson from "../../../../appAssets/jsons/saveButton.json";
import "./HeaderView.scss";
import closeIcon from "../../../../appAssets/closeIcon.png";

interface HeaderViewProps {
  titleText: string;
  textColor?: string;
  showSaveBtn?: boolean;
  onSavePress?: () => void;
  onBackPress?: () => void;
}

function HeaderView({
  titleText,
  textColor,
  showSaveBtn,
  onSavePress,
  onBackPress,
}: HeaderViewProps) {
  return (
    <div className="quest-header">
      <div className="quest-header__spacer" />
      <h1
        className="quest-header__title"
        style={textColor ? { color: textColor } : undefined}
      >
        {titleText}
      </h1>
      <div className="quest-header__right">
        {showSaveBtn && (
          <button
            type="button"
            className="quest-header__icon-btn"
            onClick={onSavePress}
            aria-label="Save"
          >
            <Lottie
              animationData={saveButtonJson}
              loop={false}
              autoplay={false}
              className="quest-header__save"
            />
          </button>
        )}
        <div onClick={onBackPress}>
          <img src={closeIcon} alt="Close" className="heart__close-icon" />
        </div>
      </div>
    </div>
  );
}

export default HeaderView;
